import React from 'react';
// Components
import LoadingSpinner from './LoadingSpinner';

function LoadingScreen() {
  return (
    <div
      id='loading-screen'
      className='grid h-screen w-full overflow-hidden justify-center items-center bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1 font-poppins'
      aria-live='polite'
      aria-busy='true'
      role='alert'
      aria-labelledby='loading-description'
    >
      <article className='grid gap-2 h-fit text-center px-8'>
        <div>
          <p id='loading-description' className='text-2xl lg:text-4xl'>
            Your Mistress is loading, wait!
          </p>
        </div>
        <div className='grid justify-center'>
          {/* Spinner for visual feedback */}
          <LoadingSpinner lg={true} />
        </div>
      </article>
    </div>
  );
}

export default LoadingScreen;
